"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Content = exports.LoaderWrapper = exports.ButtonText = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _rebass = require("rebass");

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var Wrapper = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var hasLabel = _ref.hasLabel,
      _ref$theme = _ref.theme,
      button = _ref$theme.button,
      space = _ref$theme.space,
      colors = _ref$theme.colors;
  return _defineProperty({
    borderRadius: space[button.borderRadius],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    font: 'inherit',
    textAlign: 'center',
    margin: '0',
    cursor: 'pointer',
    textDecoration: 'none',
    fontWeight: button.fontWeight,
    transform: 'none',
    lineHeight: '1.5',
    textTransform: button.textTransform,
    padding: "".concat(space[button.paddingY], " ").concat(hasLabel ? space[button.paddingX] : space[button.paddingXNoLabel]),
    width: '100%',
    transition: 'all 0.3s ease-in-out',
    opacity: 1,
    span: {
      fontSize: 'inherit'
    },
    '&:disabled': {
      background: colors[button.bgColorPrimary],
      color: colors[button.textColorPrimary],
      border: 'none',
      cursor: 'not-allowed',
      opacity: 0.2,
      span: {
        border: 'none'
      },
      '&:hover': {
        background: colors[button.bgColorPrimary],
        color: colors[button.textColorPrimary],
        border: 'none'
      }
    }
  }, _mediaQueries.default.small, {
    width: 'auto'
  });
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      button = _ref3$theme.button,
      space = _ref3$theme.space,
      inverted = _ref3.inverted;
  return (0, _styledSystem.variant)({
    variants: {
      primary: {
        background: inverted ? colors[button.bgColorInvPrimary] : colors[button.bgColorPrimary],
        color: inverted ? colors[button.textColorInvPrimary] : colors[button.textColorPrimary],
        border: button.borderPrimary,
        borderColor: colors[button.borderPrimaryColor],
        svg: {
          stroke: inverted ? colors[button.iconColorInvPrimary] : colors[button.iconColorPrimary],
          transition: 'all 0.2s ease-in-out'
        },
        '&:hover': {
          background: inverted ? colors[button.hoverBgColorInvPrimary] : colors[button.hoverBgColorPrimary],
          color: inverted ? colors[button.hoverTextColorInvPrimary] : colors[button.hoverTextColorPrimary],
          svg: {
            stroke: inverted ? colors[button.hoverIconColorInvPrimary] : colors[button.hoverIconColorPrimary]
          },
          border: button.hoverBorderPrimary,
          borderColor: colors[button.hoverBorderPrimaryColor]
        }
      },
      secondary: {
        minWidth: button.widthSecondary,
        maxWidth: button.widthSecondary,
        background: inverted ? colors[button.bgColorInvSecondary] : colors[button.bgColorSecondary],
        color: inverted ? colors[button.textColorInvSecondary] : colors[button.textColorSecondary],
        border: button.borderSecondary,
        borderColor: inverted ? colors[button.borderColorInvSecondary] : colors[button.borderColorSecondary],
        svg: {
          stroke: inverted ? colors[button.iconColorInvSecondary] : colors[button.iconColorSecondary],
          transition: 'all 0.2s ease-in-out'
        },
        '&:hover': {
          background: inverted ? colors[button.hoverBgColorInvSecondary] : colors[button.hoverBgColorSecondary],
          color: inverted ? colors[button.hoverTextColorInvSecondary] : colors[button.hoverTextColorSecondary],
          border: button.hoverBorderSecondary,
          borderColor: inverted ? colors[button.hoverBorderColorInvSecondary] : colors[button.hoverBorderColorSecondary],
          svg: {
            stroke: inverted ? colors[button.hoverIconColorInvSecondary] : colors[button.hoverIconColorSecondary]
          }
        }
      },
      link: {
        border: '0',
        background: 'transparent',
        padding: '0',
        color: inverted ? colors[button.textColorInvLink] : colors[button.textColorLink],
        svg: {
          stroke: inverted ? colors[button.iconColorInvLink] : colors[button.iconColorLink]
        },
        'span + span': {
          marginLeft: space.small
        }
      }
    }
  });
}, function (_ref4) {
  var _ref4$theme = _ref4.theme,
      button = _ref4$theme.button,
      space = _ref4$theme.space;
  return space && button && (0, _styledSystem.variant)({
    prop: 'size',
    variants: {
      large: {
        minHeight: space[button.large.height],
        height: space[button.large.height],
        fontSize: button.large.fontSize
      },
      small: {
        minHeight: space[button.small.height],
        height: space[button.small.height],
        fontSize: button.small.fontSize
      }
    }
  });
}, _styledSystem.space, _styledSystem.layout);
exports.Wrapper = Wrapper;
var ButtonText = (0, _styled.default)('span')(_styledSystem.space, function (_ref5) {
  var _ref5$theme = _ref5.theme,
      button = _ref5$theme.button,
      space = _ref5$theme.space,
      endIcon = _ref5.endIcon,
      startIcon = _ref5.startIcon;
  return {
    whiteSpace: 'nowrap',
    marginTop: button.textMargin,
    marginLeft: startIcon ? space.small : 0,
    marginRight: endIcon ? space.small : 0,
    borderBottom: '2px solid',
    borderBottomColor: 'transparent',
    transition: 'border-bottom-color 0.3s ease-in-out',
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      marginTop: button.textMarginIE
    }
  };
}, function (_ref6) {
  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      button = _ref6$theme.button,
      fonts = _ref6$theme.fonts,
      inverted = _ref6.inverted;
  return (0, _styledSystem.variant)({
    variants: {
      primary: {
        fontFamily: fonts[button.fontFamily],
        'button:hover &': {
          borderBottomColor: inverted ? colors[button.hoverBorderBottomInvPrimary] : colors[button.hoverBorderBottomPrimary]
        }
      },
      secondary: {
        fontFamily: fonts[button.fontFamily],
        fontWeight: inverted ? button.fontWeight : button.fontWeightSecondary,
        'button:hover &': {
          borderBottomColor: inverted ? colors[button.hoverBorderBottomInvSecondary] : colors[button.hoverBorderBottomSecondary]
        }
      },
      link: {
        fontFamily: fonts[button.fontFamily],
        borderBottomColor: colors[button.linkBorderBottomColor],
        'button:hover &': {
          borderBottomColor: inverted ? colors[button.hoverBorderBottomInvLink] : colors[button.hoverBorderBottomLink]
        }
      }
    }
  });
});
exports.ButtonText = ButtonText;
var LoaderWrapper = (0, _styled.default)('div')(function () {
  return {
    position: 'absolute'
  };
});
exports.LoaderWrapper = LoaderWrapper;
var Content = (0, _styled.default)('span')(function (_ref7) {
  var toggle = _ref7.toggle;
  return {
    display: 'flex',
    transition: 'opacity 0.3s',
    opacity: toggle ? '0' : '1',
    alignItems: 'center'
  };
});
exports.Content = Content;